import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import TableRowsIcon from '@mui/icons-material/TableRows'
import BaseNode from './BaseNode'
import { FieldMappingNodeData } from '../types'

const FieldMappingNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as FieldMappingNodeData
  const mappingCount = nodeData.mappings?.length ?? 0
  const subtitle = mappingCount
    ? `${mappingCount} mapping${mappingCount === 1 ? '' : 's'}`
    : 'Configure mappings...'

  return (
    <BaseNode
      nodeType="field_mapping"
      icon={<TableRowsIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    />
  )
}

export default memo(FieldMappingNode)
